import React, { useState } from 'react';
import { lookupQuestions } from '../../api';

function toHtml(s) { const t = s || ''; return t.indexOf('<') >= 0 ? t : t.split('\n').join('<br>'); }
function HtmlDiv(p) { return React.createElement('div', { style: p.style, dangerouslySetInnerHTML: { __html: toHtml(p.html) } }); }
function HtmlSpan(p) { return React.createElement('span', { style: p.style, dangerouslySetInnerHTML: { __html: toHtml(p.html) } }); }

const OPTS = ['A', 'B', 'C', 'D'];

export default function AdminQuestionLookup() {
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const onSubmit = async (e) => {
    e && e.preventDefault();
    const csv = input.trim();
    if (!csv) { setError('Enter at least one QID.'); return; }
    setError(null); setLoading(true); setData(null);
    try {
      const r = await lookupQuestions({ ids_csv: csv });
      setData(r.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Lookup failed.');
    } finally { setLoading(false); }
  };

  const onClear = () => { setInput(''); setData(null); setError(null); };

  return (
    <div style={{ maxWidth: 920, margin: '0 auto' }}>
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 26, fontFamily: 'Sora', marginBottom: 4 }}>Question Lookup</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>Paste comma-separated QIDs to see each question, options, correct answer and explanation. Admin only.</p>
        </div>
        {data && <button className="btn btn-ghost" onClick={() => window.print()}>Print / Save PDF</button>}
      </div>

      <form onSubmit={onSubmit} style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: 12, padding: 18, marginBottom: 18 }}>
        <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#475569', marginBottom: 6 }}>
          QIDs (comma, space, semicolon or newline separated)
        </label>
        <textarea
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="e.g. 315, 55, 4, 19, 274"
          rows={4}
          style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', fontFamily: 'monospace', fontSize: 14, border: '1px solid #CBD5E1', borderRadius: 8, resize: 'vertical' }}
        />
        <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Looking up…' : 'Show questions'}
          </button>
          <button type="button" className="btn btn-ghost" onClick={onClear} disabled={loading}>Clear</button>
          <div style={{ marginLeft: 'auto', fontSize: 12, color: '#94A3B8', alignSelf: 'center' }}>Max 500 QIDs per request</div>
        </div>
        {error && (
          <div style={{ marginTop: 12, background: '#FEE2E2', border: '1px solid #FCA5A5', color: '#991B1B', padding: '10px 14px', borderRadius: 8, fontSize: 13 }}>{error}</div>
        )}
      </form>

      {data && (
        <div style={{ marginBottom: 14, padding: '10px 14px', background: '#F1F5F9', border: '1px solid #CBD5E1', borderRadius: 8, fontSize: 13, color: '#334155' }}>
          Requested <strong>{data.count}</strong> &nbsp;·&nbsp; Found <strong>{data.found}</strong> &nbsp;·&nbsp; Missing <strong>{data.count - data.found}</strong>
        </div>
      )}

      {data && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {data.results.map((q, i) => q.not_found ? (
            <div key={`m-${q.question_id}`} style={{ border: '2px dashed #FCA5A5', borderRadius: 12, padding: 14, background: '#FEF2F2' }}>
              <span style={{ background: '#FEE2E2', color: '#991B1B', padding: '4px 10px', borderRadius: 8, fontFamily: 'monospace', fontWeight: 600, fontSize: 12 }}>QID {q.question_id}</span>
              <span style={{ marginLeft: 10, fontSize: 13, color: '#991B1B' }}>Not found in the question bank.</span>
            </div>
          ) : (
            <div key={q.question_id} style={{ border: '2px solid #E2E8F0', borderRadius: 12, overflow: 'hidden', background: 'white' }}>
              <div style={{ padding: '10px 16px', background: '#F8FAFC', borderBottom: '1px solid #E2E8F0', display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                <span style={{ background: '#EEF2FF', color: '#4F46E5', padding: '4px 10px', borderRadius: 8, fontWeight: 700, fontSize: 12, fontFamily: 'monospace' }}>QID: {q.question_id}</span>
                <span style={{ fontSize: 12, color: '#64748B' }}>#{i + 1}</span>
                {q.subject_name && <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: '#DBEAFE', color: '#1E40AF', fontWeight: 600 }}>{q.subject_name}</span>}
                {q.chapter_name && <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: '#F1F5F9', color: '#334155' }}>{q.chapter_name}</span>}
                {q.topic_name && <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: '#F1F5F9', color: '#475569' }}>{q.topic_name}</span>}
                {q.difficulty && <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: '#FEF3C7', color: '#92400E', fontWeight: 600 }}>{q.difficulty}</span>}
                {q.year && <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: '#F1F5F9', color: '#64748B' }}>{q.year}</span>}
                {q.flag_error_count > 0 && (
                  <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, background: '#FEE2E2', color: '#991B1B', fontWeight: 600 }}>Flagged {q.flag_error_count}×</span>
                )}
              </div>
              <div style={{ padding: 16 }}>
                {q.passage_text && (
                  <HtmlDiv html={q.passage_text} style={{ background: '#F8FAFC', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 13, lineHeight: 1.8, border: '1px solid #E2E8F0' }} />
                )}
                <HtmlDiv html={q.question_text} style={{ fontSize: 15, lineHeight: 1.7, marginBottom: 12 }} />
                {q.question_image_url && <img src={q.question_image_url} alt="" style={{ maxWidth: '100%', borderRadius: 8, marginBottom: 12 }} />}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12 }}>
                  {OPTS.map(opt => {
                    const val = q[`option_${opt.toLowerCase()}`];
                    const img = q[`option_${opt.toLowerCase()}_image_url`];
                    const isCorrect = q.correct_option === opt;
                    return (
                      <div key={opt} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 12px', borderRadius: 8, border: `2px solid ${isCorrect ? '#10B981' : '#E2E8F0'}`, background: isCorrect ? '#D1FAE5' : '#F8FAFC' }}>
                        <span style={{ width: 26, height: 26, borderRadius: 6, background: isCorrect ? '#10B981' : '#94A3B8', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 12, flexShrink: 0 }}>{opt}</span>
                        <div style={{ flex: 1 }}>
                          <HtmlSpan html={val} style={{ fontSize: 14, color: isCorrect ? '#065F46' : '#0F172A' }} />
                          {img && <div><img src={img} alt="" style={{ maxWidth: '100%', marginTop: 6, borderRadius: 6 }} /></div>}
                        </div>
                        {isCorrect && <span style={{ fontSize: 11, fontWeight: 700, padding: '2px 8px', borderRadius: 6, background: '#10B981', color: 'white' }}>Correct</span>}
                      </div>
                    );
                  })}
                </div>
                {q.explanation && (
                  <div style={{ background: '#FFFBEB', border: '1px solid #FDE68A', borderRadius: 8, padding: '12px 16px' }}>
                    <div style={{ fontSize: 11, fontWeight: 700, color: '#92400E', marginBottom: 6, textTransform: 'uppercase' }}>Explanation</div>
                    <HtmlDiv html={q.explanation} style={{ fontSize: 13, lineHeight: 1.75, color: '#78350F' }} />
                    {q.explanation_image_url && <img src={q.explanation_image_url} alt="" style={{ maxWidth: '100%', borderRadius: 6, marginTop: 10 }} />}
                  </div>
                )}
                {!q.explanation && (
                  <div style={{ background: '#F1F5F9', border: '1px dashed #CBD5E1', borderRadius: 8, padding: '10px 14px', fontSize: 12, color: '#64748B', fontStyle: 'italic' }}>
                    No explanation stored for this question.
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <style>{`@media print { form, button { display: none !important; } textarea { display: none !important; } }`}</style>
    </div>
  );
}
